import script from "./ModalInstrucciones.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalInstrucciones.vue?vue&type=script&setup=true&lang=js"

import "./ModalInstrucciones.vue?vue&type=style&index=0&id=339c97e2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-339c97e2"]])

export default __exports__